export default {
  getQuizResultsQueryParams: state => `$score=${state.score}&name=${state.name}&goalName=${state.goalName}&email=${state.email}`
}
